import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const layout = {
  namespaced: true,
  state: {
    config: {},
    theme: {},
    header: {},
    menu: {},
    breadcrumbs: {},
    sidebar: {},
    loading: {},
    footer: {},
    login: {},
    dialogs: {}
  },
  getters,
  mutations,
  actions
};
